// src/data/trainingModules.js - which training video belongs to which screen, for which role.
//
// Bob, 2026-09-28: "yes" - the six role videos go live (task list section 492). Each plays the way ruling
// 244 set for onboarding: it starts 3 s after the person first opens that part of the platform, picture and
// sound, with "Listen only" and "Turn off for this module". Ruling 245 item 1: the turn-off is kept on the
// ACCOUNT (users/{uid}.training), so it holds on every computer he signs in from.
//
// ONE list, two readers: App.js mounts the player from trainingFor(); firestore.rules allows exactly the
// module ids in MODULE_IDS under users/{uid}.training (keep the two in step - scripts\test-training-mount.mjs
// checks this file against the rules text).
//
// A role sees only videos for screens its role may open (ruling 170): every page listed here is already in
// that role's list in roleScreens.js, and trainingFor() asks mayOpen() as well, so a video can never be the
// way into a screen.
import { mayOpen, roleKey } from './roleScreens';

const OFFICERS = ['local_chair', 'general_chair', 'admin'];
const MEMBERS = ['member', 'tester'];

// Order matters: the first entry that matches the role AND the page wins.
export const TRAINING = Object.freeze([
  { module: 'agreements', title: 'Agreements library video', file: 'agreements_v5',   // 2026-10-25 review: held-documents panel precedes National agreements (s1); narration review 2026-10-16 (ruling 246): scene 9
    roles: MEMBERS.concat(OFFICERS), pages: ['agreements'] },
  { module: 'gc_committee', title: 'Committee desk video', file: 'gc_committee_v9',   // 2026-10-23 review: Messages in the menu list (776);   // 2026-10-17 (item 2): new scene 11, arbitraries and proposal cost; scene 0's old name off
    roles: ['general_chair', 'admin'], pages: ['committee'] },
  { module: 'gc_readiness', title: 'Readiness and War Room video', file: 'gc_readiness_v3',
    roles: ['general_chair', 'admin'], pages: ['readiness', 'committee-board', 'war-room'] },
  { module: 'lc_desk', title: 'Desk and applications video', file: 'lc_desk_v6',   // 2026-10-23 review: Messages in the menu list (776);   // narration review 2026-10-16 (ruling 246): scene 0
    roles: OFFICERS, pages: ['desk', 'applications', 'member-files'] },
  { module: 'lc_claims', title: 'Claims and discipline video', file: 'lc_claims_v10',   // 2026-10-25 review: open a claim from its number, not the row (s0); 2026-10-17 (item 2): new scene 11, the written decision (D-23)
    roles: OFFICERS, pages: ['claims', 'claim-detail', 'discipline', 'new-case', 'case-detail'] },
  { module: 'member_filing', title: 'Filing a claim video', file: 'member_filing_v10',   // 2026-10-25 review: notifications + Quick File behind the Dashboard Show button, open a claim from its number (s0,s1,s9); 2026-10-23 review: Messages in the menu list (776);   // narration review 2026-10-16 (ruling 246): scene 6
    roles: MEMBERS, pages: ['dashboard', 'claims', 'claim-detail', 'new-claim', 'quick-file', 'full-form'] },
  { module: 'member_help', title: 'Discipline and help video', file: 'member_help_v5',   // 2026-10-25 review: notifications behind the Show button (s4), held-documents panel (s2); 2026-10-23 review: Messages in the menu list (776)
    roles: MEMBERS, pages: ['discipline', 'case-detail', 'boards'] },
  // 2026-10-17 (item 2; ruling 320): the officers of a Local. My Local Office opens to the OFFICE, not the role (roleScreens.js
  // mayOpen reads localOffices), so every role is listed and mayOpen() decides, as for every page here.
  { module: 'local_office', title: 'My Local Office video', file: 'local_office_v1',
    roles: MEMBERS.concat(OFFICERS), pages: ['local-office'] },
]);

// Every module id the account may carry a choice for - the signed-in ones above plus the public onboarding.
export const MODULE_IDS = Object.freeze(['onboarding'].concat(TRAINING.map((t) => t.module)));

export function trainingFor(user, page) {
  if (!user || !user.role || typeof page !== 'string') return null;
  if (!mayOpen(user, page)) return null;
  const rk = roleKey(user);
  const hit = TRAINING.find((t) => t.roles.includes(rk) && t.pages.includes(page));
  if (!hit) return null;
  return { module: hit.module, title: hit.title,
           src: '/training/' + hit.file + '.mp4', captions: '/training/' + hit.file + '.vtt' };
}
